import qs from 'query-string'
import http from './_http'

const Cities = {
  closest: params => http.get(`/msvc/v1/cities/closest?${qs.stringify(params)}`, null)
}

export default Cities
